export const ConstantVariables = {
  no_photo_faculty:
    "https://s3.us-east-2.amazonaws.com/academic.online/default_photos/default_faculty_photo.png",
  no_photo_institution:
    "https://s3.us-east-2.amazonaws.com/academic.online/default_photos/default_institution_photo.png",
};
